import { SEARCH_QUICK_LINKS } from 'commons/constants';

// An order number is the entire query, optionally prefixed with "J-"/"j-",
// followed by 5–7 digits. Real order numbers fall in that range; capping at 7
// keeps longer digit runs (e.g. phone numbers) from being treated as orders,
// and the whole-query anchor stops a stray number *inside* a product search
// like "chair 12345" from hijacking it.
const ORDER_NUMBER_REGEX = /^(?:[jJ]-)?(\d{5,7})$/;

// Case-insensitive exact match: trim and collapse inner whitespace before comparing
const normalizeQuery = value =>
  value
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

/**
 * Returns a quick link match for the typed query, or null:
 * - a Page Quick Link (a SEARCH_QUICK_LINKS entry, tagged `type: 'page'`)
 *   whose keywords exactly match (case insensitive) the query, or
 * - an Order Quick Link ({ type: 'order', orderNumber, url }) when the whole
 *   query is a 5–7 digit order number, optionally prefixed with "J-".
 */
const getQuickLinkMatch = query => {
  const normalizedQuery = normalizeQuery(query || '');

  if (!normalizedQuery) {
    return null;
  }

  const quickLinkMatch = SEARCH_QUICK_LINKS.find(({ keywords }) =>
    keywords.some(keyword => normalizeQuery(keyword) === normalizedQuery)
  );

  if (quickLinkMatch) {
    return { ...quickLinkMatch, type: 'page' };
  }

  const [, orderNumber] = normalizedQuery.match(ORDER_NUMBER_REGEX) || [];

  if (orderNumber) {
    return {
      type: 'order',
      orderNumber,
      url: `/tracking/?order_id=${orderNumber}`,
    };
  }

  return null;
};

export default getQuickLinkMatch;
